module.exports = [
  require('./calm_emotions'),
  require('./chromatic_orb'),
  require('./confusion'),
  require('./conjure_elemental'),
  require('./contagion'),
  require('./create_undead'),
]
